import React from "react";
import styles from "./Accordion.module.scss";
import { Collapse } from "reactstrap";

interface AccordionProps {
  items: any[];
  children: React.ReactNode;
}

export const Accordion = ({ items, children }: AccordionProps) => {
  return items?.length ? (
    <div className={styles.accordionWrapper}>
      {items.map((item) => (
        <AccordionItem heading={item.title}>
          {!React.isValidElement(item.description) ? (
            <div dangerouslySetInnerHTML={{ __html: item.description }} />
          ) : (
            <div>{item.description}</div>
          )}
        </AccordionItem>
      ))}
    </div>
  ) : children ? (
    <div className={styles.accordionWrapper}>{children}</div>
  ) : null;
};

interface AccordionItemProps {
  children?: React.ReactNode;
  heading?: string;
}

export const AccordionItem = ({ children, heading }: AccordionItemProps) => {
  const [isOpen, setOpen] = React.useState<boolean>(false);

  const handleToggle = () => {
    setOpen(!isOpen);
  };

  return (
    <div className={styles.accordion}>
      <div className={styles.accordionHeader} onClick={handleToggle}>
        <p>{heading}</p>
        {isOpen ? (
          <svg
            width="12"
            height="3"
            viewBox="0 0 12 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="11.5"
              y1="1.5918"
              x2="-6.55671e-08"
              y2="1.5918"
              stroke="#1E9E81"
              stroke-width="1.5"
            />
          </svg>
        ) : (
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="5.59375"
              y1="3.27836e-08"
              x2="5.59375"
              y2="11.5"
              stroke="#1E9E81"
              stroke-width="1.5"
            />
            <line
              x1="11.5"
              y1="5.5918"
              x2="-6.55671e-08"
              y2="5.5918"
              stroke="#1E9E81"
              stroke-width="1.5"
            />
          </svg>
        )}
      </div>
      <Collapse isOpen={isOpen} className={styles.accordionBody}>
        {children}
      </Collapse>
    </div>
  );
};

export default Accordion;
